export const commonMenuItems = [
    {
        id: "0",
        name: "Strona główna",
        name_en: "Home page",
        link: "/",
        mobileOnly: true,
        plOnly: true,
        sitemap: ["pl", "en"],
    },
    {
        id: "1",
        name: "Gestorzy systemów",
        name_en: "Data owners",
        link: "/rsigestorzy",
        sitemap: ["pl"],
    },
    {
        id: "2",
        // name: "Systemy informacyjne (API)",
        name: "Systemy informacyjne",
        name_en: "Information systems",
        link: "/rsisystemy",
        sitemap: ["pl"],
    },
    {
        id: "3",
        name: "Typy obiektów",
        name_en: "Object type",
        link: "",
        sitemap: ["pl"],

        children: [
            {
                id: "2-3",
                name: "Osoba fizyczna",
                name_en: "Natural person",
                // link: "/rsiobiekty?typ_obiektu__icontains=osoba+fizyczna",
                link: "/rsiobiekty/osoba_fizyczna",
                path: "/rsiobiekty/osoba_fizyczna",
            },
            {
                id: "2-5",
                name: "Podmiot",
                name_en: "Entity",
                // link: "/rsiobiekty?typ_obiektu__icontains=podmiot",
                link: "/rsiobiekty/podmiot",
                path: "/rsiobiekty/podmiot",
            },
            {
                id: "2-1",
                name: "Obiekt przestrzenny",
                name_en: "Spatial object",
                // link: "/rsiobiekty?typ_obiektu__icontains=obiekt+przestrzenny",
                link: "/rsiobiekty/obiekt_przestrzenny",
                path: "/rsiobiekty/obiekt_przestrzenny",
            },
            {
                id: "2-0",
                name: "Inny",
                name_en: "Other",
                // link: "/rsiobiekty?typ_obiektu__icontains=inny",
                link: "/rsiobiekty/inny",
                path: "/rsiobiekty/inny",
            },
        ],
    },
    {
        id: "4",
        name: "Cechy informacyjne",
        name_en: "Information characteristics",
        link: "/rsicechy",
        sitemap: ["pl"],
    },
    {
        id: "5",
        name: "Pomoc",
        name_en: "Help",
        link: "/pomoc",
        sitemap: ["pl"],
        // plOnly: true,
        // children: [
        //     {
        //         id: "5-1",
        //         name:"Najczęściej zadawane pytania",
        //         name_en: "FAQ",
        //         link: "/faq",
        //         mobileOnly: true,
        //     },
        // ],
    },
];
